import { axiosInstance as axios } from "services";

export const removeCustomPlan = async (companyId) => {
  const { data } = await axios.delete(`/admin/subscription/company/${companyId}/custom-plan`);
  if (!data.success) throw new Error(data.error?.message || "Failed to remove custom plan");
  return data;
};

